"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = normalizePage;

var linkedContent = function linkedContent(response) {
  var page = response.find(function (item) {
    return item.type === 'page';
  });
  var massagedResponse = {
    pageTemplate: page.data.page_template,
    sections: page.data.body
  };
  massagedResponse.linkedContent = response.filter(function (items) {
    return items !== page;
  }).map(function (content) {
    return {
      id: content.id,
      type: content.type,
      contentData: content.data
    };
  });
  return massagedResponse;
};

function normalizePage(response) {
  return response && response.length > 0 && linkedContent(response);
}